import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        {/* <p>Effective Date: [Insert Date]</p> */}
      </div>

      <div className="privacy-content">
        <p>
          We, <strong>PSJ Capital Ventures</strong>, the creator of this Privacy Policy ensure our commitment to your privacy vis-à-vis the protection of your information.
          In order to endow you with our uninterrupted use of services, we collect, and disclose, information about you. To enhance better protection of your privacy we provide this notice explaining our information practices and the choices you can make about the way your information is collected and used.
        </p>

        <p>
          We shall use the personal information to improve our service to you and to keep you updated about our new product or information that may be of interest to you. Your information would be used by us to process your service request.
        </p>

        <h2>Overview</h2>
        <p>
          We commit to respecting your online privacy data and recognize your need for appropriate protection and management of any personally identifiable information (“Personal Information”) you share with us...
        </p>

        <h2>1. Notification of Modifications and Changes to the T&C and Privacy Policy</h2>
        <p>
          We reserve the right to change the Terms and Privacy Policy from time to time without any intimation to you...
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li>Name</li>
          <li>E-mail address</li>
          <li>Internet Protocol address</li>
          <li>Pincode</li>
          <li>Age and Gender</li>
          <li>KYC norms</li>
          <li>Financial history and situation</li>
          <li>Risk appetite, Investment objectives and duration of investments</li>
          <li>Income details</li>
          <li>Existing investments / assets</li>
          <li>Liability / borrowing details</li>
        </ul>

        <h2>3. Cookies</h2>
        <p>
          We use data collection devices such as “cookies” on certain pages of our Websites...
        </p>

        <h2>4. External Links on Website</h2>
        <p>
          The Website may include hyperlinks to other websites or content or resources. We are not responsible for the availability or accuracy of these...
        </p>

        <h2>5. Our Use of Your Information</h2>
        <ul>
          <li>To assess your risk profile</li>
          <li>To communicate with you</li>
          <li>To provide and improve services</li>
          <li>To personalize your experience</li>
          <li>To fulfill legal requirements</li>
          <li>To process payments</li>
          <li>To send newsletters or alerts</li>
        </ul>

        <h2>6. Confidentiality</h2>
        <p>
          Your information is regarded as confidential and will not be divulged to any third party except as set forth in this policy.
        </p>

        <h2>7. Our Disclosure of Your Information</h2>
        <p>
          We may disclose your Personal Information to business partners, affiliates, government authorities, or during a merger or acquisition...
        </p>

        <h2>8. Accessing, Reviewing and Changing Your Profile</h2>
        <p>
          You can review and update your profile after registration. However, certain historical data may remain in our systems for legal or technical reasons.
        </p>

        <h2>9. Control of Your Password</h2>
        <p>
          You are responsible for keeping your password secure. If compromised, update it immediately and notify us.
        </p>

        <h2>10. Other Information Collectors</h2>
        <p>
          Our privacy policy does not cover other websites linked on our site. Please review their policies before sharing your data.
        </p>

        <h2>11. Disclaimer</h2>
        <p>
          Although we are committed to protecting your data, we do not promise that your personal information will always remain private...
        </p>

        <h2>12. Disputes and Jurisdiction</h2>
        <p>
          All disputes through this policy will be resolved via the Dispute Resolution mechanism set forth in our Terms of Use / Services.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
